<div class="container form-call">
    <h2 style="text-align: center">{{ call.description }}</h2>
    <div class="content">
        <form
            class="form-container"
            [formGroup]="form"
            [action]="call.formConfig?.action"
            [target]="call.formConfig?.target"
            [method]="call.formConfig?.method"
            #formElement
        >
            @for (inputConfig of inputListConfig; track inputConfig.name) {
                @switch (inputConfig.inputType) {
                    @case ("select") {
                        <mat-form-field>
                            <mat-label>{{ inputConfig.label }}</mat-label>
                            <mat-select [formControlName]="inputConfig.name">
                                @for (option of inputConfig.sourceData; track $index) {
                                    <mat-option [value]="option">
                                        {{ option[inputConfig?.optionLabelPath ?? ""] }}
                                    </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    }
                    @case ("number") {
                        <mat-form-field>
                            <mat-label>{{ inputConfig.label }}</mat-label>
                            <input
                                matInput
                                [name]="inputConfig.name"
                                [placeholder]="inputConfig.label"
                                [formControlName]="inputConfig.name"
                                type="number"
                            />
                        </mat-form-field>
                    }
                    @case ("text") {
                        <mat-form-field>
                            <mat-label>{{ inputConfig.label }}</mat-label>
                            <input
                                matInput
                                [name]="inputConfig.name"
                                [placeholder]="inputConfig.label"
                                [formControlName]="inputConfig.name"
                            />
                        </mat-form-field>
                    }
                    @case ("password") {
                        <mat-form-field>
                            <mat-label>{{ inputConfig.label }}</mat-label>
                            <input
                                matInput
                                [name]="inputConfig.name"
                                [placeholder]="inputConfig.label"
                                [formControlName]="inputConfig.name"
                                type="password"
                            />
                        </mat-form-field>
                    }
                    @case ("boolean") {
                        <mat-slide-toggle
                            [name]="inputConfig.name"
                            [formControlName]="inputConfig.name"
                            labelPosition="before"
                        ></mat-slide-toggle>
                    }
                }
            }
        </form>
        @if (call.formConfig?.isSubmitForm && !formSubmitted) {
            <button type="submit" (click)="done()" mat-raised-button color="primary" [disabled]="!form.valid">
                {{ call.formConfig?.submitLabel || ("Submit" | translate) }}
            </button>
        } @else if (call.formConfig?.isSubmitForm && formSubmitted) {
            <button (click)="done()" mat-raised-button color="primary">
                {{ "close" | translate }}
            </button>
        } @else {
            <button (click)="done()" mat-raised-button color="primary" [disabled]="!form.valid">
                {{ call.formConfig?.submitLabel || ("Next" | translate) }}
            </button>
        }
        @if (call.formConfig?.cancelLabel) {
            <button class="form-close-btn" (click)="close()" mat-raised-button>
                {{ call.formConfig?.cancelLabel }}
            </button>
        }
    </div>
</div>
